import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

export const ScreenScrapeStepTitle = styled.h4`
  color: ${({ theme }) => theme.text.primary};
  text-align: center;
  padding: 2rem;
  font-size: 1.25rem;

  ${media.w.min.px576(css`
    padding: 2.5rem;
    font-size: 1.5rem;
  `)}
`;
